/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createQuickBooksAuthResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type QuickBooksAuthResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/quickbooks/auth
 */
export interface AuthRequestBuilder extends BaseRequestBuilder<AuthRequestBuilder> {
    /**
     * Returns the QuickBooks consent link to open in a browser so an administrator can pick a company and grant this API access to its accounting data. The link is not a connection on its own: QuickBooks sends the browser back with an authorization code and the realm id of the company that was chosen, and the connection only exists once those have been exchanged for tokens. The organization is carried through the round trip, so a code that comes back can only be applied to the organization that asked for the link. The QuickBooks client credentials must already be configured for this integration, otherwise no link can be produced.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<QuickBooksAuthResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<QuickBooksAuthResponse | undefined>;
    /**
     * Returns the QuickBooks consent link to open in a browser so an administrator can pick a company and grant this API access to its accounting data. The link is not a connection on its own: QuickBooks sends the browser back with an authorization code and the realm id of the company that was chosen, and the connection only exists once those have been exchanged for tokens. The organization is carried through the round trip, so a code that comes back can only be applied to the organization that asked for the link. The QuickBooks client credentials must already be configured for this integration, otherwise no link can be produced.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AuthRequestBuilderUriTemplate = "{+baseurl}/api/quickbooks/auth";
/**
 * Metadata for all the requests in the request builder.
 */
export const AuthRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AuthRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createQuickBooksAuthResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
